import React, { useContext } from 'react';
import { Button, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FormModalContext from '../../context/FormModalContext';
import PardotContext from '../../context/PardotContext';

const useStyles = makeStyles((theme) => ({
  emailFormField: {
    maxWidth: '370px',
    width: '100%',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.25)',
    backgroundColor: 'white',
    borderRadius: '8px 0 0 10px',
    height: '50px',
    border: 'none',
    color: '#4B5B69',
    paddingLeft: '10px',
    fontSize: '18px',

    '&:focus': {
      outline: 'none',
      boxShadow: '0 0 10px rgba(0, 0, 0, 0.25)',
    },

    [theme.breakpoints.down('sm')]: {
      maxWidth: 'auto',
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: 'auto',
      width: '100%',
    },
  },
  emailFormButton: {
    background: '#0380B6',
    border: 'none !important',
    boxShadow: 'none !important',
    borderRadius: '0px 8px 8px 0px',
    maxHeight: '50px',
    color: '#fff',
    height: '50px',
    fontWeight: '700',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.25)',
    minWidth: '160px',
    '&:hover': {
      opacity: '1 !important',
      background: '#002D5C',
      color: '#fff',
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: '137px',
    },
  },
}));

export const EmailForm = ({ ctaText, fs }) => {
  const classes = useStyles();
  const { handleModalClick } = useContext(FormModalContext);
  const { email, setEmail } = useContext(PardotContext);
  const handleChange = (e) => {
    const { value } = e.target;

    setEmail(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleModalClick();
  };

  return (
    <form className={classes.emailform} onSubmit={(e) => handleSubmit(e)}>
      <Box display='flex' alignItems='center'>
        <input
          className={classes.emailFormField}
          variant='none'
          size='small'
          label='Enter Email'
          value={email}
          placeholder='Enter your email address'
          onChange={(e) => handleChange(e)}
        />
        <Button
          onClick={(e) => handleSubmit(e)}
          className={classes.emailFormButton}
          type='submit'
          variant='contained'
          size='medium'
        >
          GET DEMO
        </Button>
      </Box>
    </form>
  );
};
